module.exports = __webpack_public_path__ + "img/contact-count.b0ff86f9.svg";